import KunLoading105 from './src/index'

KunLoading105.install = function (Vue) {
	Vue.component(KunLoading105.name, KunLoading105);
}

export default KunLoading105;
